class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.anchor = this.querySelector("a");
    if (!this.anchor) return;

    // Add click event listener instead of intersection observer
    this.anchor.addEventListener('click', (e) => {
      e.preventDefault();
      this.loadNextPage();
    });
  }

  async loadNextPage() {
    // Show loading state
    this.anchor.innerText = "Indlæser...";

    const url = this.anchor.getAttribute("href");
    if (!url) return;

    try {
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, "text/html");

      // Grab the product grid from the next page
      const newGrid = html.querySelector("[data-product-grid]");
      const grid = document.querySelector("[data-product-grid]");

      if (newGrid && grid) {
        Array.from(newGrid.children).forEach((child) => {
          grid.appendChild(child);
        });
      }

      // Handle next infinite scroll
      const newInfinite = html.querySelector("infinite-scroll");
      if (newInfinite) {
        this.replaceWith(newInfinite);
      } else {
        // No more pages, hide the button
        this.anchor.style.display = "none";
      }
    } catch (err) {
      console.error("InfiniteScroll error:", err);
      // Reset button on error
      this.anchor.innerText = "Indlæs mere";
    }
  }
}

customElements.define("infinite-scroll", InfiniteScroll);
